import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ContentContainer } from '../../../../core/content-container/content-container';
import { ScrollTo } from '../../../../shared/scroll-to/directives/scroll-to';
import { AngularMonolithComponent } from './components/angular-monolith/angular-monolith';

@Component({
  selector: 'app-first',
  imports: [ContentContainer, ScrollTo, AngularMonolithComponent],
  templateUrl: './first.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class First {}
